import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RouterErrorElement from './RouterErrorElement';

// sample page routing

const Renewal = Loadable(lazy(() => import('views/renewal')));
const Account = Loadable(lazy(() => import('views/account')));
const Equipment = Loadable(lazy(() => import('views/equipment')));
const Order = Loadable(lazy(() => import('views/order')));
const Software = Loadable(lazy(() => import('views/software')));
const Rebate = Loadable(lazy(() => import('views/rebate')));
const Loading = Loadable(lazy(() => import('views/loading')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    errorElement: <RouterErrorElement />,
    children: [
        {
            path: '/',
            element: <Renewal />
        },
        {
            path: '/renewal',
            element: <Renewal />
        },
        {
            path: '/equipment',
            element: <Equipment />
        },
        {
            path: '/software',
            element: <Software />
        },
        {
            path: '/account',
            element: <Account />
        },
        {
            path: '/order/:type',
            element: <Order />
        },
        {
            path: '/rebate',
            element: <Rebate />
        },
        {
            path: '/loading',
            element: <Loading />
        }
    ]
};

export default MainRoutes;
